import { createSlice } from '@reduxjs/toolkit';
import { ROLES, DEFAULT_ROLE_PERMISSIONS } from '../constants';

// Rehydrate from localStorage so auth persists across page refreshes
const storedUser = localStorage.getItem('user');
const storedRole = localStorage.getItem('user_role');
let storedPermissions = null;
try {
  const p = localStorage.getItem('user_permissions');
  if (p) storedPermissions = JSON.parse(p);
} catch {
  storedPermissions = null;
}

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: storedUser ? JSON.parse(storedUser) : null,
    role: storedRole || ROLES.user,
    isSuperAdmin: localStorage.getItem('is_super_admin') === 'true',
    permissions: storedPermissions || DEFAULT_ROLE_PERMISSIONS[storedRole || ROLES.user] || DEFAULT_ROLE_PERMISSIONS[ROLES.user],
  },
  reducers: {
    setUser: (state, action) => {
      const { user, role, permissions, isSuperAdmin } = action.payload;
      state.user = user;
      state.role = role || ROLES.user;
      state.isSuperAdmin = Boolean(isSuperAdmin || role === ROLES.admin);
      state.permissions = permissions || DEFAULT_ROLE_PERMISSIONS[role || ROLES.user] || DEFAULT_ROLE_PERMISSIONS[ROLES.user];

      // Sync to localStorage for persistence
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('user_role', state.role);
      localStorage.setItem('is_super_admin', String(state.isSuperAdmin));
      localStorage.setItem('user_permissions', JSON.stringify(state.permissions));
    },
    updatePermissions: (state, action) => {
      if (action.payload.role) {
        state.role = action.payload.role;
        localStorage.setItem('user_role', state.role);
      }
      if (action.payload.permissions) {
        state.permissions = action.payload.permissions;
        localStorage.setItem('user_permissions', JSON.stringify(state.permissions));
      }
      if (action.payload.isSuperAdmin !== undefined) {
        state.isSuperAdmin = Boolean(action.payload.isSuperAdmin);
        localStorage.setItem('is_super_admin', String(state.isSuperAdmin));
      }
    },
    clearUser: (state) => {
      state.user = null;
      state.role = ROLES.user;
      state.isSuperAdmin = false;
      state.permissions = DEFAULT_ROLE_PERMISSIONS[ROLES.user];

      localStorage.removeItem('user');
      localStorage.removeItem('user_role');
      localStorage.removeItem('is_super_admin');
      localStorage.removeItem('user_permissions');
    },
  },
});

export const { setUser, updatePermissions, clearUser } = authSlice.actions;
export default authSlice.reducer;

// ─── Selectors ─────────────────────────────────────────────────────────────────
export const selectUser             = (state) => state.auth.user;
export const selectRole             = (state) => state.auth.role;
export const selectIsAdmin          = (state) => state.auth.role === ROLES.admin;
export const selectIsSuperAdmin     = (state) => Boolean(state.auth.isSuperAdmin || state.auth.role === ROLES.admin);
export const selectIsManager        = (state) => state.auth.role === ROLES.manager || state.auth.role === ROLES.admin;
export const selectModulePermissions= (state) => state.auth.permissions || DEFAULT_ROLE_PERMISSIONS[ROLES.user];
